import { api } from '../api';

export type CfdMicroservice =
  | 'cross-farm-dashboard'
  | 'cross-farm-dashboard-v2';

type CfdMicroserviceResolver = (homeAggregation?: string) => CfdMicroservice;

let microserviceResolver: CfdMicroserviceResolver = () =>
  'cross-farm-dashboard';

export const setCrossFarmDashboardMicroserviceResolver = (
  resolver: CfdMicroserviceResolver,
) => {
  microserviceResolver = resolver;
};

export const getCrossFarmDashboardMicroservice = (
  homeAggregation?: string,
): CfdMicroservice => microserviceResolver(homeAggregation);

export interface CfdElkResponse<THitSource = unknown> {
  hits: {
    hits: { _id: string; _source: THitSource }[];
    total: { value: number; relation: string };
  };
}

export const requestDataCFD = <TResult = unknown>(
  query: object,
  includeClosedCS: boolean = false,
  isScopedSearch: boolean = false,
): Promise<TResult> => {
  const microservice = getCrossFarmDashboardMicroservice();
  const resource = isScopedSearch ? '_scoped_search' : '_search';

  const url = includeClosedCS
    ? `${microservice}/${resource}?includeClosedCropSeasons=true`
    : `${microservice}/${resource}`;

  return api.post(url, JSON.stringify(query)) as unknown as Promise<TResult>;
};

export const requestDataHFCFD = <TResult = unknown>(
  query: object,
): Promise<TResult> => {
  const microservice = `${getCrossFarmDashboardMicroservice()}/hf`;
  const resource = '_search';

  return api.post(
    `${microservice}/${resource}`,
    JSON.stringify(query),
  ) as unknown as Promise<TResult>;
};

export const requestDataSustainabilityCFD = <TResult = unknown>(
  query: object,
): Promise<TResult> => {
  const microservice = `${getCrossFarmDashboardMicroservice()}/sustainability`;
  const resource = '_search';

  return api.post(
    `${microservice}/${resource}`,
    JSON.stringify(query),
  ) as unknown as Promise<TResult>;
};
